/** Switch click to hover mega menu **/
if (!navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi|Tablet|iPad/i)) {
    document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
        summary.addEventListener('mouseenter', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            summary.parentElement.setAttribute('open', 'true');
        });
        summary.addEventListener('mouseleave', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            summary.parentElement.removeAttribute('open');
        });
        if (summary.parentElement.querySelector('.mega-menu__content')) {
            summary.parentElement.querySelector('.mega-menu__content').addEventListener('mouseenter', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
                summary.parentElement.setAttribute('open', 'true');
            });
            summary.parentElement.querySelector('.mega-menu__content').addEventListener('mouseleave', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
                summary.parentElement.removeAttribute('open');
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var announcementSwiper = new Swiper(".announcementSwiper", {
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 9000,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    var featuredProductsSwiper = new Swiper(".featuredProductsSwiper", {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".fp-btn-next",
            prevEl: ".fp-btn-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            750: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    var articleMentionedProducts = new Swiper(".articleMentionedProducts", {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".amp-btn-next",
            prevEl: ".amp-btn-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            750: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    var featuredCollectionsSwiper = new Swiper(".featuredCollectionsSwiper", {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".fc-btn-next",
            prevEl: ".fc-btn-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            750: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });


    var featuredBlogPostsSwiper = new Swiper(".featuredPostsSwiper", {
        loop: true,
        effect: "cube",
        navigation: {
            nextEl: ".bp-btn-next",
            prevEl: ".bp-btn-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });


    document.querySelectorAll(".productPageBtn").forEach(btn => {
        btn.addEventListener("click", () => {
            const tab = btn.dataset.tab;

            document.querySelectorAll(".productPageBtn").forEach(b => b.classList.remove("active"));
            btn.classList.add("active");

            document.querySelectorAll(".productPageContent").forEach(c => {
                c.classList.toggle("active", c.id === tab);
            });
        });
    });

});

